// src/utils/socket.ts
import * as io from 'socket.io-client';
import store from '../redux/store';

const REACT_APP_CHATCON_URL = process.env.REACT_APP_CHATCON_URL;

class Socket {
    private static _instance: io.Socket | null = null;

    static getInstance(): io.Socket {
        if (!this._instance) {
            this._instance = this._createSocket();
        }
        return this._instance;
    }

    static refreshSocket(): io.Socket {
        if (this._instance) {
            this._instance.close();
        }
        this._instance = this._createSocket();
        return this._instance;
    }

    private static _createSocket(): io.Socket {
        const { user } = store.getState();
        const instance = io.connect(REACT_APP_CHATCON_URL, {
            closeOnBeforeunload: false,
            path: '/socket',
            transports: ['websocket', 'longpolling'],
            query: {
                authorization: user.user?.customerToken,
                sessionId: user.user?.sessionId,
                dialogId: user.user?.providerDialogId,
                engagementId: user.user?.engagementId,
            },
        });

        instance.on('connect_error', () => console.log('Connection failed'));
        instance.on('reconnect_failed', () => console.log('Reconnection failed'));

        return instance;
    }

    static close(): void {
        if (this._instance) {
            this._instance.close();
        }
    }
}

export default Socket;
